export function dashboardDevicesJson (language) {
  let items

  if (language === 'es') {
    items = {
      idCard: {
        name: 'idCard',
        label: 'card con el identificador del dispositivo'
      },
      modelCard: {
        name: 'modelCard',
        label: 'card con el modelo y la marca del dispositivo'
      },
      serialNumberCard: {
        name: 'serialNumberCard',
        label: 'card con el número de serie del dispositivo'
      },
      lastConnectionCard: {
        name: 'lastConnectionCard',
        label: 'card con la última conexión del dispositivo'
      },
      soCard: {
        name: 'soCard',
        label: 'card con el sistema operativo del dispositivo'
      },
      statusDeviceCard: {
        name: 'statusDeviceCard',
        label: 'card con el estado del dispositivo'
      },
      codeEstablishment: {
        name: 'codeEstablishment',
        label: 'card con el código del establecimiento'
      },
      addressEstablishment: {
        name: 'addressEstablishment',
        label: 'card con la dirección del establecimiento'
      },
      diskChartDashboardDevice: {
        name: 'diskChartDashboardDevice',
        label: 'gráfico de disco'
      },
      ramChartDashboardDevice: {
        name: 'ramChartDashboardDevice',
        label: 'gráfico de ram'
      },
      battery: {
        name: 'battery',
        label: 'estado de la batería'
      },
      lastLocationMap: {
        name: 'lastLocationMap',
        label: 'mapa con la última ubicación del dispositivo'
      },
      moreLocationsButton: {
        name: 'moreLocationsButton',
        label: 'mostrar más ubicaciones del dispositivo'
      },
      moreConnectionsButton: {
        name: 'moreConnectionsButton',
        label: 'mostrar más conexiones del dispositivo'
      },
      connectionsVerticalBar: {
        name: 'connectionsVerticalBar',
        label: 'gráfico de barras verticales con las últimas conexiones del dispositivo'
      },
      devicesUseTimeChart: {
        name: 'devicesUseTimeChart',
        label: 'gráfico del tiempo de uso promedio del dispositivo'
      },
      actionShutdown: {
        name: 'actionShutdown',
        label: 'apagar dispositivo'
      },
      actionReboot: {
        name: 'actionReboot',
        label: 'reiniciar dispositivo'
      },
      actionWipe: {
        name: 'actionWipe',
        label: 'formatear de fábrica el dispositivo'
      },
      // actionErrorLogs: {
      //   name: 'actionErrorLogs',
      //   label: 'mostrar los logs de errores del dispositivo'
      // },
      actionSendCommand: {
        name: 'actionSendCommand',
        label: 'enviar commandos al dispositivo'
      },
      actionSendMessage: {
        name: 'actionSendMessage',
        label: 'enviar mensaje'
      },
      actionContentDownload: {
        name: 'actionContentDownload',
        label: 'descargar contenido en el dispositivo'
      },
      actionBackgroundChange: {
        name: 'actionBackgroundChange',
        label: 'cambiar el fondo de pantalla en el dispositivo'
      },
      actionReports: {
        name: 'actionReports',
        label: 'ver los reportes del dispositivo'
      },
      actionLockDevice: {
        name: 'actionLockDevice',
        label: 'bloquear y desbloquear dispositivo'
      },
      actionActivateDevice: {
        name: 'actionActivateDevice',
        label: 'activar y desactivar dispositivo'
      },
      actionDeleteFolders: {
        name: 'actionDeleteFolders',
        label: 'eliminar carpetas del dispositivo'
      },
      actionApplications: {
        name: 'actionApplications',
        label: 'mostrar aplicaciones'
      },
      actionInstallApplications: {
        name: 'actionInstallApplications',
        label: 'instalar y desinstalar aplicaciones'
      },
      /*       actionRxartSecure: {
        name: 'actionRxartSecure',
        label: 'administrar Rxart Secure'
      }, */
      actionEstablishment: {
        name: 'actionEstablishment',
        label: 'administrar Establecimiento'
      },
      actionLockScreen: {
        name: 'actionLockScreen',
        label: 'bloquear la pantalla del dispositivo'
      },
      actionModifyScreenBrightness: {
        name: 'actionModifyScreenBrightness',
        label: 'modificar el brillo de la pantalla del dispositivo'
      },
      actionMissingDevice: {
        name: 'actionMissingDevice',
        label: 'reportar el dispositivo como faltante'
      },
      exportPdfInAllDevicesConnections: {
        name: 'exportPdfInAllDevicesConnections',
        label: 'exportar el historial de conexiones del equipo en formato pdf'
      },
      exportCsvInAllDevicesConnections: {
        name: 'exportCsvInAllDevicesConnections',
        label: 'exportar el historial de conexiones del equipo en formato csv'
      }
    }
  } else if (language === 'en') {
    items = {
      idCard: {
        name: 'idCard',
        label: 'card with the device identifier'
      },
      modelCard: {
        name: 'modelCard',
        label: 'card with the model and brand of the device'
      },
      serialNumberCard: {
        name: 'serialNumberCard',
        label: 'card with the serial number of the device'
      },
      lastConnectionCard: {
        name: 'lastConnectionCard',
        label: 'card with the last device connection'
      },
      soCard: {
        name: 'soCard',
        label: 'card with the operating system of the device'
      },
      statusDeviceCard: {
        name: 'statusDeviceCard',
        label: 'card with the device status'
      },
      codeEstablishment: {
        name: 'codeEstablishment',
        label: 'card with the establishment code'
      },
      addressEstablishment: {
        name: 'addressEstablishment',
        label: 'card with the address of the establishment'
      },
      diskChartDashboardDevice: {
        name: 'diskChartDashboardDevice',
        label: 'disk graph'
      },
      ramChartDashboardDevice: {
        name: 'ramChartDashboardDevice',
        label: 'ram graph'
      },
      battery: {
        name: 'battery',
        label: 'battery status'
      },
      lastLocationMap: {
        name: 'lastLocationMap',
        label: 'map with the last location of the device'
      },
      moreLocationsButton: {
        name: 'moreLocationsButton',
        label: 'show more device locations'
      },
      moreConnectionsButton: {
        name: 'moreConnectionsButton',
        label: 'show more device connections'
      },
      connectionsVerticalBar: {
        name: 'connectionsVerticalBar',
        label: 'vertical bar chart with the latest device connections'
      },
      devicesUseTimeChart: {
        name: 'devicesUseTimeChart',
        label: 'graph of average device usage time'
      },
      actionShutdown: {
        name: 'actionShutdown',
        label: 'turn off device'
      },
      actionReboot: {
        name: 'actionReboot',
        label: 'reboot device'
      },
      actionWipe: {
        name: 'actionWipe',
        label: 'factory format the device'
      },
      // actionErrorLogs: {
      //   name: 'actionErrorLogs',
      //   label: 'mostrar los logs de errores del dispositivo'
      // },
      actionSendCommand: {
        name: 'actionSendCommand',
        label: 'send commands to the device'
      },
      actionSendMessage: {
        name: 'actionSendMessage',
        label: 'send message'
      },
      actionContentDownload: {
        name: 'actionContentDownload',
        label: 'download content to the device'
      },
      actionBackgroundChange: {
        name: 'actionBackgroundChange',
        label: 'change the wallpaper on your device'
      },
      actionReports: {
        name: 'actionReports',
        label: 'view device reports'
      },
      actionLockDevice: {
        name: 'actionLockDevice',
        label: 'lock and unlock device'
      },
      actionActivateDevice: {
        name: 'actionActivateDevice',
        label: 'activate and deactivate device'
      },
      actionDeleteFolders: {
        name: 'actionDeleteFolders',
        label: 'delete folders from the device'
      },
      actionApplications: {
        name: 'actionApplications',
        label: 'show apps'
      },
      actionInstallApplications: {
        name: 'actionInstallApplications',
        label: 'install and uninstall applications'
      },
      /*       actionRxartSecure: {
        name: 'actionRxartSecure',
        label: 'manage Rxart Secure'
      }, */
      actionEstablishment: {
        name: 'actionEstablishment',
        label: 'manage Establishment'
      },
      actionLockScreen: {
        name: 'actionLockScreen',
        label: 'lock the device screen'
      },
      actionModifyScreenBrightness: {
        name: 'actionModifyScreenBrightness',
        label: 'change the brightness of the screen of the device'
      },
      actionMissingDevice: {
        name: 'actionMissingDevice',
        label: 'report the device as missing'
      },
      exportPdfInAllDevicesConnections: {
        name: 'exportPdfInAllDevicesConnections',
        label: 'export the connections history of the device in PDF format'
      },
      exportCsvInAllDevicesConnections: {
        name: 'exportCsvInAllDevicesConnections',
        label: 'export the connections history of the device in CSV format'
      }
    }
  }

  return (items)
}
